import { AiOutlineMail } from 'react-icons/ai'
import { IoLogoFacebook, IoLogoGithub, IoLogoLinkedin, IoLogoWhatsapp } from 'react-icons/io'

export const predeterminedContacts = [
  {
    name: 'email',
    icon: <AiOutlineMail />,
    url: 'mailto:steven.novaryo@gmail.com',
  },
  {
    name: 'whatapps',
    icon: <IoLogoWhatsapp />,
    url: 'https://api.whatsapp.com/send?phone=+6282150532993',
  },
  {
    name: 'facebook',
    icon: <IoLogoFacebook />,
    url: 'https://www.facebook.com/steven.novaryo1/',
  },
  {
    name: 'github',
    icon: <IoLogoGithub />,
    url: 'https://github.com/stevennovaryo',
  },
  {
    name: 'linkedin',
    icon: <IoLogoLinkedin />,
    url: 'https://www.linkedin.com/in/steven-novaryo-67944b1b7/'
  }
]